import { Navigate, useLocation } from 'react-router-dom'
import { type ReactNode } from 'react'
import { useRBAC } from '@/hooks/useRBAC'
import CustomLoader from './CustomLoader'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({
  children,
}: Readonly<ProtectedRouteProps>) {
  const location = useLocation()
  const { canAccess, isLoading, getDefaultPath } = useRBAC()

  if (isLoading) {
    return <CustomLoader />
  }

  const hasAccess = canAccess(location.pathname)
  if (hasAccess) {
    return <>{children}</>
  }

  const defaultPath = getDefaultPath()
  return <Navigate to={defaultPath} state={{ from: location }} replace />
}
